import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@material-ui/icons/Cancel";
import { transactionModalClosed } from "../../store/components";
import Loader3Orange from "../../general/Loader3Orange";
import DateFnsUtils from "@date-io/date-fns";
import Check from "@material-ui/icons/Check";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
const TransactionDetails = (props) => {
  const dateFns = new DateFnsUtils();
  const [isLoading, setIsLoading] = useState(false);
  const subscription = props.subscription;
  const data = props.detail.details;
  const dispatch = useDispatch();
  return (
    <>
      <h5
        className="px-2"
        style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.5vw",
          display: "flex",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        Transaction Details
      </h5>
      <div style={{ position: "absolute", top: 0, right: 0 }}>
        <CancelIcon
          fontSize="large"
          style={{ cursor: "pointer" }}
          onClick={() => dispatch(transactionModalClosed())}
        ></CancelIcon>
      </div>
      <div>{isLoading ? <Loader3Orange></Loader3Orange> : null}</div>
      <div className="px-3 mb-3">
        <div className="card" style={{ borderRadius: "10px" }}>
          <div className="card-body">
            <h4 className="card-title fw-normal mb-3 border-bottom ">
              <div className="mb-3">
                {" "}
                <b>
                  <span
                    style={{
                      fontFamily: "GibsonSemiBd",
                      fontSize: "1.5vw",
                      display: "flex",
                      marginLeft: "1rem",
                    }}
                  >
                    Subscription Details
                  </span>
                </b>
              </div>
            </h4>
            <div
              className="px-3 card-text"
              style={{ fontFamily: "GibsonRegular" }}
            >
              <div className="float-right">
                <div className="row ">
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> Subscription Name</span>
                    <span className="float-right text-dark">
                      {subscription && subscription.subscription_name
                        ? subscription.subscription_name
                        : "-"}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary float-left">
                      {" "}
                      Subscription Amount
                    </span>
                    <span className="float-right text-dark">
                      $
                      {subscription && subscription.subscription_price
                        ? subscription.subscription_price
                        : "0"}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary">Start Date </span>
                    <span className="float-right text-dark">
                      {dateFns.format(
                        new Date(subscription.createdAt),
                        "MMM dd, yyyy"
                      )}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary">Tax </span>
                    <span className="float-right ">
                      $
                      {subscription && subscription.tax
                        ? subscription.tax
                        : "0"}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary">Next Renewal Date </span>
                    <span className="float-right text-dark">
                      {dateFns.format(
                        new Date(subscription.next_renewal_date),
                        "MMM dd, yyyy"
                      )}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> Total Amount </span>
                    <span className="float-right text-dark">
                      {" "}
                      $
                      {subscription && subscription.total_amount
                        ? subscription.total_amount
                        : "0"}
                    </span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-3">
        <div className="card" style={{ borderRadius: "10px" }}>
          <div className="card-body">
            <h4 className="card-title fw-normal mb-3 border-bottom ">
              <div className="mb-3">
                {" "}
                <b>
                  <span
                    style={{
                      fontFamily: "GibsonSemiBd",
                      fontSize: "1.5vw",
                      display: "flex",
                      marginLeft: "1rem",
                    }}
                  >
                    Payment Method
                  </span>
                </b>
              </div>
            </h4>
            <div
              className="px-3 mb-3 card-text"
              style={{ fontFamily: "GibsonRegular" }}
            >
              <div className="float-right">
                <div className="row ">
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary float-left"> Last 4 </span>
                    <span className="float-right text-dark">
                      ....{data && data.payment_method_details.card.last4}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> FingerPrint </span>
                    <span className="float-right text-primary">
                      {data && data.source.fingerprint}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> Expires </span>
                    <span className="float-right text-dark">
                      {data && data.source.exp_month}/
                      {data && data.source.exp_year}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> Type </span>
                    <span className="float-right text-dark">
                      {" "}
                      {data && data.payment_method_details.type}&nbsp;
                      {data && data.payment_method_details.card.brand}
                    </span>

                    <br />
                  </div>
                  <div className="col-md-6 mb-2">
                    <span className="text-secondary"> Issuer </span>{" "}
                    <span className="float-right"> Stripe Payments</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-3 mt-3 mb-3">
        <div className="card" style={{ borderRadius: "10px" }}>
          <div className="card-body">
            <h4 className="card-title fw-normal mb-3 border-bottom ">
              <div className="mb-3">
                {" "}
                <b>
                  <span
                    style={{
                      fontFamily: "GibsonSemiBd",
                      fontSize: "1.5vw",
                      display: "flex",
                      marginLeft: "1rem",
                    }}
                  >
                    Payment Details
                  </span>
                </b>
              </div>
            </h4>
            <div className="card-text" style={{ fontFamily: "GibsonRegular" }}>
              <div className="row ml-1">
                <div className="col-md-6">
                  <div className="mb-2">
                    <span className="text-secondary"> Amount </span>
                    <span className="float-right text-dark">
                      {" "}
                      ${data && data.amount / 100}
                    </span>
                    <br />
                  </div>
                  <div className="mb-2">
                    <span className="text-secondary"> Status </span>
                    <span className="float-right badge badge-success">
                      {data && data.status}
                    </span>
                    <br />
                  </div>
                  <div className="mb-2">
                    <span className="text-secondary"> Description </span>
                    <span className="float-right text-black-50">
                      {data && data.description
                        ? data.description
                        : "No Description"}
                    </span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetails;
